import gql from 'graphql-tag';

export default gql`
  query project($id: Int!) {
    project(id: $id) {
      id
      status
    }
  }
`;
